import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

const Header = ({ institute, fromDate, toDate }) => (
  <View style={styles.header}>
    <View style={styles.logoContainer}>
      {institute?.instituteLogo && (
        <Image
          src={institute.instituteLogo}
          style={styles.logo}
        />
      )}
    </View>

    <View style={styles.titleContainer}>
      <Text style={styles.schoolName}>
        {institute?.instituteName}
      </Text>

      <Text style={styles.address}>
        {institute?.instituteAddress}
      </Text>

      <Text style={styles.contact}>
        Contact: {institute?.instituteMobileNo} | Email: {institute?.instituteEmail}
      </Text>

      <Text style={styles.title}>
        Collection Report
      </Text>


    </View>
  </View>
);

const styles = StyleSheet.create({

  page: {
    padding: 20,
    fontSize: 10
  },


  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: "#cfcfcf",
    paddingBottom: 10,
  },

  logoContainer: {
    width: 80,
    justifyContent: "center",
    alignItems: "center",
  },

  titleContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 80, // balances the logo width
  },

  logo: {
    width: 65,
    height: 65,
    objectFit: "contain",
  },

  schoolName: {
    fontSize: 18,
    fontWeight: "bold",
  },

  address: {
    fontSize: 9,
    marginTop: 2,
  },
  head: {
    backgroundColor: "#eeeeee",
    fontWeight: "bold",
  },

  table: {
    display: "table",
    width: "100%",
    marginTop: 5,
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  },
  contact: {
    fontSize: 9,
    marginTop: 2,
  },

  title: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: "bold",
  },

  subTitle: {
    marginTop: 4,
    fontSize: 10,
  },


  row: {
    flexDirection: "row",
    alignItems: "center",
  },



  cell: {
    padding: 4,
    fontSize: 10,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  }

});
const CollectionReport = ({
  report,
  fromDate,
  toDate
}) => {
  const institute = report.institute;
  const groups = report.data;
  const grandTotal = report.grandTotal;
  const installmentColumns = report.installmentColumns || [];


  const fixedWidth = 62;

  const dynamicWidth =
    installmentColumns.length
      ? (100 - fixedWidth) / installmentColumns.length
      : 0;

  return (

    <Document>

      <Page
        size="A4"
        style={styles.page}
      >

        <Header
          institute={institute}
          fromDate={fromDate}
          toDate={toDate}
        />
        {
          groups.map((group, index) => (

            <View key={index}>

              <Text style={styles.date}>
                Receipt Date : {group.paymentDate}
              </Text>

              <View style={styles.table}>

                <View style={[styles.row, styles.head]}>

                  <Text style={[styles.cell, { width: "7%" }]}>
                    #
                  </Text>



                  <Text style={[styles.cell, { width: "24%" }]}>
                    Name
                  </Text>

                  <Text style={[styles.cell, { width: "14%" }]}>
                    Class-Sec
                  </Text>

                  <Text style={[styles.cell, { width: "15%" }]}>
                    Receipt
                  </Text>

                  {
                    installmentColumns.map((column) => (

                      <Text
                        key={column}
                        style={[
                          styles.cell,
                          {
                            width: `${dynamicWidth}%`,

                          }
                        ]}
                      >
                        {column}
                      </Text>

                    ))
                  }

                  <Text
                    style={[
                      styles.cell,
                      {
                        width: "10%",

                      }
                    ]}
                  >
                    Total
                  </Text>

                </View>

                {
                  group.payments.map((student, i) => (

                    <View
                      key={i}
                      style={styles.row}
                    >

                      <Text style={[styles.cell, { width: "7%" }]}>
                        {i + 1}
                      </Text>


                      <Text style={[styles.cell, { width: "24%" }]}>
                        {student.studentName}
                      </Text>

                      <Text style={[styles.cell, { width: "14%" }]}>
                        {student.className}
                      </Text>

                      <Text style={[styles.cell, { width: "15%" }]}>
                        {student?.receiptNo}
                      </Text>
                      {
                        installmentColumns.map((column) => {

                          const installment = student.installments[column];

                          return (
                            <Text
                              key={column}
                              style={[
                                styles.cell,
                                {
                                  width: `${dynamicWidth}%`,

                                }
                              ]}
                            >
                              {
                                installment && installment.paidAmount > 0
                                  ? `${installment.paidAmount}`
                                  : "-"
                              }
                            </Text>
                          );

                        })
                      }

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.total}
                      </Text>

                    </View>

                  ))
                }

              </View>

              <View
                style={{
                  alignItems: "flex-end",
                  marginTop: 5
                }}
              >

                <Text
                  style={{
                    fontWeight: "bold"
                  }}
                >

                  Group Total : {group.totalAmount}

                </Text>

              </View>

            </View>

          ))
        }

        <View
          style={{
            marginTop: 20,
            alignItems: "flex-end"
          }}
        >

          <Text
            style={{
              fontWeight: "bold",
              fontSize: 12
            }}
          >

            Grand Total : {grandTotal}

          </Text>

        </View>

      </Page>

    </Document>

  );

};

export default CollectionReport;